import * as React from 'react';

import * as styles from './Thumbnails.css';
import { IDailyRentOfferForMobileSite } from '../../../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { LazyImage } from '../Carousel/components/LazyImage';

export const Thumbnails = (props: Pick<IDailyRentOfferForMobileSite, 'media'>) => {
  const { media } = props;
  const ref = React.useRef(null);

  return (
    <div className={styles['thumbnails']} ref={ref}>
      {media.slice(1, 4).map(media => (
        <LazyImage key={media.previewUrl} containerRef={ref} src={media.previewUrl} alt="" />
      ))}
    </div>
  );
};
